<template>
  <div id="contenedor-editar-detalle">
    <v-form
      v-model="formularioValido"
      ref="actualizarObservacionDetalle">
      <v-card>
        <v-card-title>
          Editar Desglose de Observación
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <!-- Seleccionar contrato -->
            <v-col cols="12" md="12">
              <CustomSelect
              v-if="!observacion.idContrato"
              v-model="observacionDetalle.idContrato"
              label="Cotrato"
              :items="getAuditoriaContratos"
              item-text="contrato"
              item-value="id">
            </CustomSelect>
            </v-col>
            <v-col
              cols="12" md="12">
              <TextArea
                v-model="observacionDetalle.texto"
                label="Desglose"
                placeholder="Descripción del desglose"
                rows="3"
                :rules="[mixReglas.requerido]">
              </TextArea>
            </v-col>
            <CustomDatePicker
              v-model="observacionDetalle.fechaVencimiento"
              cols="12"
              md="6"
              label="Fecha vencimiento"
              :rules="[mixReglas.requerido]">
            </CustomDatePicker>
            <v-col
              cols="12" md="6">
            </v-col>
            <v-col>
              <TextArea
                v-model="observacionDetalle.comentarios"
                label="Comentarios"
                rows="3">
              </TextArea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
            </custom-button>
          <custom-button
            @click="guardar"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario "
            :loading="enviandoFormulario"
            >
            </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import mixObservaciones from '../mixObservaciones';

export default {
  name: 'EditarDetalle',
  mixins: [mixObservaciones],
  components: {
    CustomDatePicker,
    TextArea,
    CustomButton,
    CustomSelect,
  },
  props: {
    detalle: {
      type: Object,
      required: true,
    },
    informe: {
      type: Object,
      required: true,
    },
    observacion: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      observacionDetalle: {
        idContrato: this.detalle.idContrato,
        requiereAccion: this.detalle.requiereAccion,
        requiereDocumento: this.detalle.requiereDocumento,
        texto: this.detalle.texto,
        fechaVencimiento: this.detalle.fechaVencimiento,
        enviado: this.detalle.enviado,
        comentarios: this.detalle.comentarios,
      },
    };
  },
  methods: {
    limpiarFormularioDetalle() {
      this.$refs.actualizarObservacionDetalle.reset();
    },
    async guardar() {
      await this.mixActualizarAuditoriaInformeObservacionDetalle();
    },
    cerrar() {
      this.limpiarFormularioDetalle();
      this.$emit('cerrar');
    },
  },
  computed: {
    getAuditoriaContratos() {
      if (!this.auditoriasContratos) return [];
      return this.auditoriasContratos.map((c) => ({
        contrato: c.contrato.numero,
        id: c.contrato.id,
      }));
    },
  },
};
</script>

<style lang="scss">

</style>
